export const pathology = {
  // Вкладка «Акты вскрытия»
  act: {
    viewList: '[perm]-[pathology]-view-act-list',
    view: '[perm]-[pathology]-view-act',
    create: '[perm]-[pathology]-create-act',
    edit: '[perm]-[pathology]-edit-act',
    sign: '[perm]-[pathology]-sign-act',
    print: '[perm]-[pathology]-print-act',
  },
} as const;
